    import { useCallback, useEffect, useState } from "react";
    import { ControllerListarSegurosClinica } from "../../../Service/Services.seguros";
    import { ListarProcedimientoConPrecios } from "../../../Service/Service.examen";
    import SelectSearchable from "../../SelectSeachble/SelectSearchble";
    import { GetTokenDecoded } from "../../../utils/storeUsuario";
    import { Col, Modal, Row, Spinner } from "react-bootstrap";
    import { Input, InputNumber, Table } from "antd";
    import Swal from "sweetalert2";
    import { PostNewPromocion } from "../../../Service/Service.promocion";

    function PromocionPrecioNuevoModal({ data }) {

        const { show, handleClose } = data;
        const [loading, setLoading] = useState(false);
        const [searchText, setSearchText] = useState('');
        const [listarProcedimientos, setListarProcedimientos] = useState([]);
        const [seguros, setSeguros] = useState([]);
        const [selectedSeguroOption, setSelectedSeguroOption] = useState(null);
        const [nombrePromocion, setNombrePromocion] = useState("");
        const [selectedRowKeys, setSelectedRowKeys] = useState([]);
        const [selectedProcedimientos, setSelectedProcedimientos] = useState([]);

        const columns = [
            {
                title: 'Código',
                dataIndex: ['ExamenTipo', 'codigo'],
                key: 'codigo',
                width: 80,
            },
            {
                title: 'Descripción',
                dataIndex: ['ExamenTipo', 'descripcion'],
                key: 'ExamenTipo.descripcion',
                width: 250,
            },
            {
                title: 'Precio',
                dataIndex: 'precio',
                key: 'precio',
                width: 80,
                align: 'right',
                render: (_, record) => (<>{record.precio.toFixed(2)}</>),
            },
            {
                title: 'Seguro',
                dataIndex: ['Seguros', 'nombre'],
                key: 'nombre',
                width: 100,
            },
            {
                title: 'Precio Promoción',
                dataIndex: 'precio_promocion',
                key: 'precio_promocion',
                width: 150,
                align: 'right',
                render: (_, record) => {
                    const selectedRecord = selectedProcedimientos.find(p => p.idprocedimiento_company_precios === record.idprocedimiento_company_precios) || record;

                    return (
                        <InputNumber
                            min={0}
                            precision={2}
                            size="small"
                            value={selectedRecord.precio_promocion}
                            onChange={(value) => handlePriceChange(value, record)}
                            disabled={!selectedRowKeys.includes(record.idprocedimiento_company_precios)}

                        />
                    );
                },
            },        
        ];

        const handlePriceChange = (value, record) => {
            setSelectedProcedimientos((prev) => {
                return prev.map((item) =>
                    item.idprocedimiento_company_precios === record.idprocedimiento_company_precios ? { ...item, precio_promocion: value } : item
                );
            });
        };

        const onRowSelectionChangeNuevo = (selectedRowKeys, selectedRows) => {
            setSelectedRowKeys(selectedRowKeys);
            setSelectedProcedimientos(prev => {
                return selectedRows.map(row => {
                    const existing = prev.find(p => p.idprocedimiento_company_precios === row.idprocedimiento_company_precios);
                    return existing ? existing : { ...row, precio_promocion: row.precio_promocion ?? "" };
                });
            });
        }; 

        const rowSelectionNuevo = {
            selectedRowKeys,
            onChange: onRowSelectionChangeNuevo,
            preserveSelectedRowKeys: true, 
        };

        const handleSearch = (value) => {
            setSearchText(value);
        };

        const handleChangeSeguro = selectedSeguroOption => {
            setSelectedSeguroOption(selectedSeguroOption);
            fetchProcedimientos(selectedSeguroOption.value);
            setSelectedRowKeys([]);
            setSelectedProcedimientos([]);
        };

        const filteredData = listarProcedimientos.filter((proc) =>
            proc.ExamenTipo.codigo.toLowerCase().includes(searchText.toLowerCase()) ||
            proc.ExamenTipo.descripcion.toLowerCase().includes(searchText.toLowerCase())
        );

        // TARIFARIOS-PERF-02: el filtro por aseguradora lo hace el SERVIDOR.
        // Antes se pedia el tarifario COMPLETO de las 19 aseguradoras (9.590
        // filas / 4,32 MB) y se descartaba el 90 % con un `.filter` en el
        // navegador. Las filas que se muestran son EXACTAMENTE las mismas;
        // solo cambia donde se filtra.
        const fetchProcedimientos = useCallback(async (seguroId) => {
            setLoading(true);
            const response = await ListarProcedimientoConPrecios({ seguro_id: seguroId });
            if (response.success) {
                setListarProcedimientos(response.data);
            }
            // Antes `setLoading(false)` estaba DENTRO del `if`: si la peticion
            // fallaba, el modal se quedaba cargando para siempre.
            setLoading(false);
        }, []);

        const fetchInitialData = useCallback(async () => {
            const dataSeguro = await ControllerListarSegurosClinica(GetTokenDecoded().idclinica);
            const segurosOptions = dataSeguro.map((seg) => ({ value: seg.idseguro, label: seg.nombre }));
            setSeguros(segurosOptions);

            if (segurosOptions.length > 0) {
                setSelectedSeguroOption(segurosOptions[0]);
                fetchProcedimientos(segurosOptions[0].value);
            }

        }, [fetchProcedimientos]);

        useEffect(() => {
            fetchInitialData();
        }, [fetchInitialData]);

        const handleAgregarPromocion = async () => {
            try {

                const procedimientosInvalidos = selectedProcedimientos.some(ex => 
                    ex.precio_promocion === null || 
                    ex.precio_promocion === undefined || 
                    ex.precio_promocion === ""
                );
        
                if (procedimientosInvalidos) {
                    Swal.fire({
                        icon: "warning",
                        title: "Advertencia",
                        text: "Todos los procedimientos seleccionados deben tener un precio de promoción válido.",
                    });
                    return;
                }
                            setLoading(true);
                const payload = {
                    cabecera: { 
                        nombre: nombrePromocion,
                        seguro_id: selectedSeguroOption.value
                    },
                    detalle: selectedProcedimientos.map( ex => ({
                        id_tipo_examen: ex.idExamenTipo,
                        precio_promocion: ex.precio_promocion,
                        idprocedimiento_company_precios:ex.idprocedimiento_company_precios
                    }))
                }

                const response = await PostNewPromocion(payload);
                if(!response.success) {
                    throw new Error(response.message);
                }

                setSelectedRowKeys([]);
                setSelectedProcedimientos([]);
                setNombrePromocion("")

                handleClose();
                Swal.fire({
                    icon: "success",
                    title: "Éxito",
                    text: response.message,
                    showConfirmButton: true,
                });

            } catch (response) {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: response.message || "Hubo un error al crear la promoción",
                });

            } finally {
                setLoading(false);
            }
        };

        return (
            <Modal show={show} backdrop="static" onHide={handleClose} keyboard={false} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Crear Promoci&oacute;n</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Row>
                        <Col>
                            <div className="d-flex w-100 justify-content-between align-items-center pb-2">
                                <Input
                                    placeholder="Buscar por código o descripción"
                                    value={searchText}
                                    onChange={(e) => handleSearch(e.target.value)}
                                    className="me-2 w-75"
                                />
                                <div className="w-auto">
                                    {/* <label className="form-label text-secondary"><small>Entidad / Seguro</small></label> */}
                                    <SelectSearchable
                                        listCompany={seguros}
                                        handleChange={handleChangeSeguro}
                                        selectedOption={selectedSeguroOption}
                                        placeholder="Seleccione"
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col>

                            <Table dataSource={searchText ? filteredData : listarProcedimientos}
                                columns={columns}
                                size='small'
                                scroll={{ x: "max-content", y: 250 }}
                                rowSelection={rowSelectionNuevo}
                                rowKey={(record) => record.idprocedimiento_company_precios}
                                loading={loading} />

                        </Col>
                    </Row>

                </Modal.Body>

                <Modal.Footer>
                    <div className="d-flex w-100 justify-content-between align-items-center">
                        <Input
                            placeholder="Nombre de la promoción"
                            value={nombrePromocion}
                            className="w-75"
                            onChange={(e) => setNombrePromocion(e.target.value)}
                        />

                        <button className="btn btn-primary" onClick={handleAgregarPromocion} disabled={loading || !nombrePromocion || !selectedProcedimientos.length }>
                            {loading ? (
                                <>
                                    <Spinner
                                        as="span"
                                        animation="grow"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    {" "}Por favor espere...
                                </>
                            ) : "Crear"}
                        </button>
                    </div>
                </Modal.Footer>

            </Modal>
        )
    }

    export default PromocionPrecioNuevoModal;

